// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Core__Int = require("@rescript/core/src/Core__Int.res.js");
var Expln_test = require("../../rescript-utils/main/Expln_test.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_wrk_editor = require("./MM_wrk_editor.res.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.res.js");

function proofStatusEq(a, b) {
  if (a !== undefined) {
    if (b !== undefined) {
      return a === b;
    } else {
      return false;
    }
  } else {
    return b === undefined;
  }
}

function hash(status) {
  if (status === undefined) {
    return 0;
  }
  switch (status) {
    case "Ready" :
        return 1;
    case "Waiting" :
        return 2;
    case "NoJstf" :
        return 3;
    case "JstfIsIncorrect" :
        return 4;
    
  }
}

var ProofStatusHash = Belt_Id.MakeHashableU({
      hash: hash,
      eq: proofStatusEq
    });

function hash$1(b) {
  if (b) {
    return 1;
  } else {
    return 0;
  }
}

function eq(a, b) {
  return a === b;
}

var BoolHash = Belt_Id.MakeHashableU({
      hash: hash$1,
      eq: eq
    });

function isStmtStatusRemove(diff) {
  if (diff.TAG === "StmtStatus") {
    return diff.proofStatus === undefined;
  } else {
    return false;
  }
}

function isStmtStatusSet(diff) {
  if (diff.TAG === "StmtStatus") {
    return diff.proofStatus !== undefined;
  } else {
    return false;
  }
}

function isStmtMove(diff) {
  if (diff.TAG === "StmtMove") {
    return true;
  } else {
    return false;
  }
}

function allMoveAndStatusSet(diff) {
  return diff.every(function (d) {
              if (isStmtMove(d)) {
                return true;
              } else {
                return isStmtStatusSet(d);
              }
            });
}

function editorSnapshotMake(st) {
  return {
          descr: st.descr,
          varsText: st.varsText,
          disjText: st.disjText,
          stmts: st.stmts.map(function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        typ: stmt.typ,
                        isGoal: stmt.isGoal,
                        isBkm: stmt.isBkm,
                        jstfText: stmt.jstfText,
                        cont: MM_wrk_editor.contToStr(stmt.cont),
                        proofStatus: stmt.proofStatus
                      };
              })
        };
}

function updateEditorStateFromSnapshot(st, sn) {
  return {
          preCtxData: st.preCtxData,
          tabTitle: st.tabTitle,
          descr: sn.descr,
          descrEditMode: st.descrEditMode,
          varsText: sn.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          wrkCtxColors: st.wrkCtxColors,
          disjText: sn.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: sn.stmts.map(function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: false,
                        typ: stmt.typ,
                        typEditMode: false,
                        isGoal: stmt.isGoal,
                        isBkm: stmt.isBkm,
                        cont: MM_wrk_editor.strToCont(stmt.cont, Caml_option.some(st.preCtxData.symColors), Caml_option.some(st.wrkCtxColors)),
                        contEditMode: false,
                        isDuplicated: false,
                        jstfText: stmt.jstfText,
                        jstfEditMode: false,
                        stmtErr: undefined,
                        expr: undefined,
                        jstf: undefined,
                        proofTreeDto: undefined,
                        src: undefined,
                        proof: undefined,
                        proofStatus: stmt.proofStatus,
                        unifErr: undefined,
                        syntaxErr: undefined
                      };
              }),
          checkedStmtIds: st.checkedStmtIds,
          nextAction: st.nextAction
        };
}

function updateStmt(sn, stmtId, update) {
  return {
          descr: sn.descr,
          varsText: sn.varsText,
          disjText: sn.disjText,
          stmts: sn.stmts.map(function (stmt) {
                if (stmt.id === stmtId) {
                  return update(stmt);
                } else {
                  return stmt;
                }
              })
        };
}

function addStmt(sn, idx, stmt) {
  var newStmts = sn.stmts.slice();
  newStmts.splice(idx, 0, stmt);
  return {
          descr: sn.descr,
          varsText: sn.varsText,
          disjText: sn.disjText,
          stmts: newStmts
        };
}

function removeStmt(sn, stmtId) {
  return {
          descr: sn.descr,
          varsText: sn.varsText,
          disjText: sn.disjText,
          stmts: sn.stmts.filter(function (stmt) {
                return stmt.id !== stmtId;
              })
        };
}

function applyDiffSingle(sn, diff) {
  switch (diff.TAG) {
    case "Descr" :
        return {
                descr: diff._0,
                varsText: sn.varsText,
                disjText: sn.disjText,
                stmts: sn.stmts
              };
    case "Vars" :
        return {
                descr: sn.descr,
                varsText: diff._0,
                disjText: sn.disjText,
                stmts: sn.stmts
              };
    case "Disj" :
        return {
                descr: sn.descr,
                varsText: sn.varsText,
                disjText: diff._0,
                stmts: sn.stmts
              };
    case "StmtLabel" :
        var label = diff.label;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    }));
    case "StmtTyp" :
        var isGoal = diff.isGoal;
        var typ = diff.typ;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: typ,
                              isGoal: isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    }));
    case "StmtBkm" :
        var isBkm = diff.isBkm;
        var stmtIds = diff.stmtIds;
        return {
                descr: sn.descr,
                varsText: sn.varsText,
                disjText: sn.disjText,
                stmts: sn.stmts.map(function (stmt) {
                      if (stmtIds.includes(stmt.id)) {
                        return {
                                id: stmt.id,
                                label: stmt.label,
                                typ: stmt.typ,
                                isGoal: stmt.isGoal,
                                isBkm: isBkm,
                                jstfText: stmt.jstfText,
                                cont: stmt.cont,
                                proofStatus: stmt.proofStatus
                              };
                      } else {
                        return stmt;
                      }
                    })
              };
    case "StmtJstf" :
        var jstfText = diff.jstfText;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    }));
    case "StmtCont" :
        var cont = diff.cont;
        return updateStmt(sn, diff.stmtId, (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: cont,
                              proofStatus: stmt.proofStatus
                            };
                    }));
    case "StmtStatus" :
        var proofStatus = diff.proofStatus;
        var stmtIds$1 = diff.stmtIds;
        return {
                descr: sn.descr,
                varsText: sn.varsText,
                disjText: sn.disjText,
                stmts: sn.stmts.map(function (stmt) {
                      if (stmtIds$1.includes(stmt.id)) {
                        return {
                                id: stmt.id,
                                label: stmt.label,
                                typ: stmt.typ,
                                isGoal: stmt.isGoal,
                                isBkm: stmt.isBkm,
                                jstfText: stmt.jstfText,
                                cont: stmt.cont,
                                proofStatus: proofStatus
                              };
                      } else {
                        return stmt;
                      }
                    })
              };
    case "StmtAdd" :
        return addStmt(sn, diff.idx, diff.stmt);
    case "StmtRemove" :
        var stmtIds$2 = diff.stmtIds;
        return {
                descr: sn.descr,
                varsText: sn.varsText,
                disjText: sn.disjText,
                stmts: sn.stmts.filter(function (stmt) {
                      return !stmtIds$2.includes(stmt.id);
                    })
              };
    case "StmtMove" :
        var stmtId = diff.stmtId;
        var idx = diff.idx;
        var stmt = sn.stmts.find(function (stmt) {
              return stmt.id === stmtId;
            });
        if (stmt === undefined) {
          return sn;
        }
        var sn$1 = removeStmt(sn, stmtId);
        return addStmt(sn$1, idx, stmt);
    
  }
}

function applyDiff(sn, diff) {
  return Core__Array.reduce(diff, sn, applyDiffSingle);
}

function findDiff(a, b) {
  var diffs = [];
  var aIds = Belt_HashSetString.fromArray(a.stmts.map(function (stmt) {
            return stmt.id;
          }));
  var bIds = Belt_HashSetString.fromArray(b.stmts.map(function (stmt) {
            return stmt.id;
          }));
  var stmtIdsToRemove = [];
  a.stmts.forEach(function (stmtA) {
        if (!Belt_HashSetString.has(bIds, stmtA.id)) {
          stmtIdsToRemove.push(stmtA.id);
          return ;
        }
        
      });
  if (stmtIdsToRemove.length !== 0) {
    diffs.push({
          TAG: "StmtRemove",
          stmtIds: stmtIdsToRemove
        });
  }
  b.stmts.forEach(function (stmtB, i) {
        if (!Belt_HashSetString.has(aIds, stmtB.id)) {
          diffs.push({
                TAG: "StmtAdd",
                idx: i,
                stmt: stmtB
              });
          return ;
        }
        
      });
  var aMod = {
    contents: applyDiff(a, diffs)
  };
  var aModLen = aMod.contents.stmts.length;
  var bLen = b.stmts.length;
  if (aModLen !== bLen) {
    var aIdsStr = "[" + a.stmts.map(function (stmt) {
            return stmt.id;
          }).join(",") + "]";
    var bIdsStr = "[" + b.stmts.map(function (stmt) {
            return stmt.id;
          }).join(",") + "]";
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "aModLen != bLen (aModLen=" + aModLen.toString() + ", bLen=" + bLen.toString() + ", " + ("aIds=" + aIdsStr + ", bIds=" + bIdsStr + ")")
          },
          Error: new Error()
        };
  }
  for(var i = 0; i < bLen; ++i){
    var stmtA = aMod.contents.stmts[i];
    var stmtB = b.stmts[i];
    if (stmtA.id !== stmtB.id) {
      var move_0 = stmtB.id;
      var move = {
        TAG: "StmtMove",
        stmtId: move_0,
        idx: i
      };
      diffs.push(move);
      aMod.contents = applyDiffSingle(aMod.contents, move);
    }
    
  }
  var isBkms = Belt_HashMap.make(2, BoolHash);
  var proofStatuses = Belt_HashMap.make(5, ProofStatusHash);
  b.stmts.forEach(function (stmtB, i) {
        var stmtA = aMod.contents.stmts[i];
        if (stmtA.id !== stmtB.id) {
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "stmtA.id != stmtB.id"
                },
                Error: new Error()
              };
        }
        if (stmtA.label !== stmtB.label) {
          diffs.push({
                TAG: "StmtLabel",
                stmtId: stmtB.id,
                label: stmtB.label
              });
        }
        if (stmtA.typ !== stmtB.typ || stmtA.isGoal !== stmtB.isGoal) {
          diffs.push({
                TAG: "StmtTyp",
                stmtId: stmtB.id,
                typ: stmtB.typ,
                isGoal: stmtB.isGoal
              });
        }
        if (stmtA.isBkm !== stmtB.isBkm) {
          var stmtIds = Belt_HashMap.get(isBkms, stmtB.isBkm);
          if (stmtIds !== undefined) {
            stmtIds.push(stmtB.id);
          } else {
            Belt_HashMap.set(isBkms, stmtB.isBkm, [stmtB.id]);
          }
        }
        if (stmtA.jstfText !== stmtB.jstfText) {
          diffs.push({
                TAG: "StmtJstf",
                stmtId: stmtB.id,
                jstfText: stmtB.jstfText
              });
        }
        if (stmtA.cont !== stmtB.cont) {
          diffs.push({
                TAG: "StmtCont",
                stmtId: stmtB.id,
                cont: stmtB.cont
              });
        }
        if (proofStatusEq(stmtA.proofStatus, stmtB.proofStatus)) {
          return ;
        }
        var stmtIds$1 = Belt_HashMap.get(proofStatuses, stmtB.proofStatus);
        if (stmtIds$1 !== undefined) {
          stmtIds$1.push(stmtB.id);
          return ;
        } else {
          return Belt_HashMap.set(proofStatuses, stmtB.proofStatus, [stmtB.id]);
        }
      });
  Belt_HashMap.forEach(isBkms, (function (isBkm, stmtIds) {
          diffs.push({
                TAG: "StmtBkm",
                stmtIds: stmtIds,
                isBkm: isBkm
              });
        }));
  Belt_HashMap.forEach(proofStatuses, (function (proofStatus, stmtIds) {
          diffs.push({
                TAG: "StmtStatus",
                stmtIds: stmtIds,
                proofStatus: proofStatus
              });
        }));
  if (a.descr !== b.descr) {
    diffs.push({
          TAG: "Descr",
          _0: b.descr
        });
  }
  if (a.varsText !== b.varsText) {
    diffs.push({
          TAG: "Vars",
          _0: b.varsText
        });
  }
  if (a.disjText !== b.disjText) {
    diffs.push({
          TAG: "Disj",
          _0: b.disjText
        });
  }
  return diffs;
}

function editorHistMake(initState, maxLength) {
  return {
          ver: 2,
          head: editorSnapshotMake(initState),
          prev: [],
          maxLength: Math.max(0, Math.min(1000, maxLength))
        };
}

function prependDiffToFirstElem(diff, prev, maxLength) {
  if (diff.length === 0) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "diff->Array.length == 0"
          },
          Error: new Error()
        };
  }
  if (prev.length === 0) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "prev->Array.length == 0"
          },
          Error: new Error()
        };
  }
  return [diff.concat(prev[0])].concat(prev.slice(1, maxLength));
}

function editorHistAddSnapshot(ht, st) {
  if (MM_wrk_editor.isEditMode(st)) {
    return ht;
  }
  var newHead = editorSnapshotMake(st);
  if (ht.maxLength === 0) {
    return {
            ver: ht.ver,
            head: newHead,
            prev: [],
            maxLength: ht.maxLength
          };
  }
  var diff = findDiff(newHead, ht.head);
  if (diff.length === 0 || diff.every(isStmtStatusSet)) {
    return ht;
  } else if (diff.every(isStmtStatusRemove)) {
    if (ht.prev.length === 0) {
      return {
              ver: ht.ver,
              head: newHead,
              prev: ht.prev,
              maxLength: ht.maxLength
            };
    } else {
      return {
              ver: ht.ver,
              head: newHead,
              prev: prependDiffToFirstElem(diff, ht.prev, ht.maxLength),
              maxLength: ht.maxLength
            };
    }
  } else if (allMoveAndStatusSet(diff) && ht.prev.length > 0 && allMoveAndStatusSet(ht.prev[0])) {
    return {
            ver: ht.ver,
            head: newHead,
            prev: prependDiffToFirstElem(diff, ht.prev, ht.maxLength),
            maxLength: ht.maxLength
          };
  } else {
    return {
            ver: ht.ver,
            head: newHead,
            prev: [diff].concat(ht.prev.slice(0, ht.maxLength - 1 | 0)),
            maxLength: ht.maxLength
          };
  }
}

function editorHistSetMaxLength(ht, maxLength) {
  if (maxLength === ht.maxLength) {
    return ht;
  } else {
    return {
            ver: ht.ver,
            head: ht.head,
            prev: ht.prev.slice(0, maxLength),
            maxLength: maxLength
          };
  }
}

function editorHistIsEmpty(ht) {
  return ht.prev.length === 0;
}

function editorHistLength(ht) {
  return ht.prev.length;
}

function editorHistGetSnapshotPreview(ht, idx, st) {
  if (idx === -1) {
    return {
            TAG: "Ok",
            _0: MM_wrk_editor.recalcWrkColors(updateEditorStateFromSnapshot(st, ht.head))
          };
  }
  var histLen = ht.prev.length;
  if (histLen === 0 || histLen <= idx) {
    return {
            TAG: "Error",
            _0: "histLen == 0 || histLen <= idx"
          };
  }
  var curSn = ht.head;
  for(var i = 0; i <= idx; ++i){
    curSn = applyDiff(curSn, ht.prev[i]);
  }
  return {
          TAG: "Ok",
          _0: MM_wrk_editor.recalcWrkColors(updateEditorStateFromSnapshot(st, curSn))
        };
}

function restoreEditorStateFromSnapshot(st, ht, idx) {
  return Belt_Result.map(editorHistGetSnapshotPreview(ht, idx, st), (function (st) {
                return {
                        preCtxData: st.preCtxData,
                        tabTitle: st.tabTitle,
                        descr: st.descr,
                        descrEditMode: st.descrEditMode,
                        varsText: st.varsText,
                        varsEditMode: st.varsEditMode,
                        varsErr: st.varsErr,
                        wrkCtxColors: st.wrkCtxColors,
                        disjText: st.disjText,
                        disjEditMode: st.disjEditMode,
                        disjErr: st.disjErr,
                        wrkCtx: st.wrkCtx,
                        nextStmtId: st.nextStmtId,
                        stmts: st.stmts.map(function (stmt) {
                              var newrecord = Caml_obj.obj_dup(stmt);
                              newrecord.proofStatus = undefined;
                              return newrecord;
                            }),
                        checkedStmtIds: st.checkedStmtIds,
                        nextAction: st.nextAction
                      };
              }));
}

function selectMaxId(id1, id2) {
  if (id1 !== undefined) {
    if (id2 !== undefined) {
      return Math.max(id1, id2);
    } else {
      return id1;
    }
  } else {
    return id2;
  }
}

function getMaxIntStmtIdFromDiffs(diffs) {
  return Core__Array.reduce(diffs, undefined, (function (maxId, diff) {
                switch (diff.TAG) {
                  case "Descr" :
                  case "Vars" :
                  case "Disj" :
                      return maxId;
                  case "StmtAdd" :
                      return selectMaxId(maxId, Core__Int.fromString(diff.stmt.id, undefined));
                  case "StmtBkm" :
                  case "StmtStatus" :
                  case "StmtRemove" :
                      break;
                  default:
                    return selectMaxId(maxId, Core__Int.fromString(diff.stmtId, undefined));
                }
                return Core__Array.reduce(diff.stmtIds, maxId, (function (maxId, stmtId) {
                              return selectMaxId(maxId, Core__Int.fromString(stmtId, undefined));
                            }));
              }));
}

function editorHistGetMaxIntStmtId(ht) {
  var maxId = Core__Array.reduce(ht.head.stmts, undefined, (function (maxId, stmt) {
          return selectMaxId(maxId, Core__Int.fromString(stmt.id, undefined));
        }));
  return Core__Array.reduce(ht.prev, maxId, (function (maxId, diffs) {
                return selectMaxId(maxId, getMaxIntStmtIdFromDiffs(diffs));
              }));
}

function editorStatesHaveSameContent(st1, st2) {
  var sn1 = editorSnapshotMake(st1);
  var sn2 = editorSnapshotMake(st2);
  if (sn1.descr === sn2.descr && sn1.varsText === sn2.varsText && sn1.disjText === sn2.disjText && sn1.stmts.length === sn2.stmts.length) {
    return Core__Array.reduceWithIndex(sn1.stmts, true, (function (res, stmt1, idx) {
                  if (!res) {
                    return res;
                  }
                  var stmt2 = sn2.stmts[idx];
                  if (stmt1.label === stmt2.label && stmt1.typ === stmt2.typ && stmt1.isGoal === stmt2.isGoal && stmt1.isBkm === stmt2.isBkm && stmt1.jstfText === stmt2.jstfText) {
                    return stmt1.cont === stmt2.cont;
                  } else {
                    return false;
                  }
                }));
  } else {
    return false;
  }
}

function editorHistoryPrintIdInfo(ht) {
  console.log("--- History id info ---------------------------");
  console.log("maxStmtId", editorHistGetMaxIntStmtId(ht));
  ht.prev.forEach(function (diffs, i) {
        var addRemoveStmts = diffs.map(function (diff) {
                    switch (diff.TAG) {
                      case "StmtAdd" :
                          return "+" + diff.stmt.id;
                      case "StmtRemove" :
                          return "-" + diff.stmtIds.join(",");
                      default:
                        return ;
                    }
                  }).filter(function (__x) {
                  return Core__Option.isSome(__x);
                }).map(function (__x) {
                return Core__Option.getExn(__x, undefined);
              }).join(", ");
        if (addRemoveStmts.length > 0) {
          console.log((i + 1 | 0).toString() + ": " + addRemoveStmts);
          return ;
        }
        
      });
  console.log("-----------------------------------------------");
}

function proofStatusToStr(status) {
  switch (status) {
    case "Ready" :
        return "r";
    case "Waiting" :
        return "w";
    case "NoJstf" :
        return "n";
    case "JstfIsIncorrect" :
        return "i";
    
  }
}

function proofStatusFromStr(str) {
  switch (str) {
    case "i" :
        return "JstfIsIncorrect";
    case "n" :
        return "NoJstf";
    case "r" :
        return "Ready";
    case "w" :
        return "Waiting";
    default:
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to proofStatus."
            },
            Error: new Error()
          };
  }
}

function stmtSnapshotToLocStor(stmt) {
  return {
          d: stmt.id,
          l: stmt.label,
          t: MM_wrk_editor.userStmtTypeToStr(stmt.typ),
          g: stmt.isGoal,
          b: stmt.isBkm,
          j: stmt.jstfText,
          c: stmt.cont,
          p: Belt_Option.map(stmt.proofStatus, proofStatusToStr)
        };
}

function stmtSnapshotFromLocStor(stmt) {
  return {
          id: stmt.d,
          label: stmt.l,
          typ: MM_wrk_editor.userStmtTypeFromStr(stmt.t),
          isGoal: stmt.g,
          isBkm: stmt.b,
          jstfText: stmt.j,
          cont: stmt.c,
          proofStatus: Belt_Option.map(stmt.p, proofStatusFromStr)
        };
}

function editorSnapshotToLocStor(sn) {
  return {
          d: sn.descr,
          v: sn.varsText,
          j: sn.disjText,
          s: sn.stmts.map(stmtSnapshotToLocStor)
        };
}

function editorSnapshotFromLocStor(sn) {
  return {
          descr: sn.d,
          varsText: sn.v,
          disjText: sn.j,
          stmts: sn.s.map(stmtSnapshotFromLocStor)
        };
}

function editorDiffToLocStor(diff) {
  switch (diff.TAG) {
    case "Descr" :
        return {
                t: "D",
                s: diff._0
              };
    case "Vars" :
        return {
                t: "V",
                s: diff._0
              };
    case "Disj" :
        return {
                t: "J",
                s: diff._0
              };
    case "StmtLabel" :
        return {
                t: "SL",
                d: diff.stmtId,
                s: diff.label
              };
    case "StmtTyp" :
        return {
                t: "ST",
                d: diff.stmtId,
                b: diff.isGoal,
                s: MM_wrk_editor.userStmtTypeToStr(diff.typ)
              };
    case "StmtBkm" :
        return {
                t: "SB",
                b: diff.isBkm,
                a: diff.stmtIds
              };
    case "StmtJstf" :
        return {
                t: "SJ",
                d: diff.stmtId,
                s: diff.jstfText
              };
    case "StmtCont" :
        return {
                t: "SC",
                d: diff.stmtId,
                s: diff.cont
              };
    case "StmtStatus" :
        return {
                t: "SS",
                s: Belt_Option.map(diff.proofStatus, proofStatusToStr),
                a: diff.stmtIds
              };
    case "StmtAdd" :
        return {
                t: "SA",
                i: diff.idx,
                m: stmtSnapshotToLocStor(diff.stmt)
              };
    case "StmtRemove" :
        return {
                t: "SR",
                a: diff.stmtIds
              };
    case "StmtMove" :
        return {
                t: "SM",
                d: diff.stmtId,
                i: diff.idx
              };
    
  }
}

function optGetEdls(opt, typ, attrName) {
  if (opt !== undefined) {
    return Caml_option.valFromOption(opt);
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "'" + attrName + "' is not set in an editorDiffLocStor for typ = '" + typ + "'."
        },
        Error: new Error()
      };
}

function edlsGetId(d) {
  return optGetEdls(d.d, d.t, "d");
}

function edlsGetIds(d) {
  return optGetEdls(d.a, d.t, "a");
}

function edlsGetBool(d) {
  return optGetEdls(d.b, d.t, "b");
}

function edlsGetInt(d) {
  return optGetEdls(d.i, d.t, "i");
}

function edlsGetStr(d) {
  return optGetEdls(d.s, d.t, "s");
}

function edlsGetStmt(d) {
  return optGetEdls(d.m, d.t, "m");
}

function editorDiffFromLocStor(diff) {
  var match = diff.t;
  switch (match) {
    case "D" :
        return {
                TAG: "Descr",
                _0: edlsGetStr(diff)
              };
    case "J" :
        return {
                TAG: "Disj",
                _0: edlsGetStr(diff)
              };
    case "SA" :
        return {
                TAG: "StmtAdd",
                idx: edlsGetInt(diff),
                stmt: stmtSnapshotFromLocStor(edlsGetStmt(diff))
              };
    case "SB" :
        return {
                TAG: "StmtBkm",
                stmtIds: edlsGetIds(diff),
                isBkm: edlsGetBool(diff)
              };
    case "SC" :
        return {
                TAG: "StmtCont",
                stmtId: edlsGetId(diff),
                cont: edlsGetStr(diff)
              };
    case "SJ" :
        return {
                TAG: "StmtJstf",
                stmtId: edlsGetId(diff),
                jstfText: edlsGetStr(diff)
              };
    case "SL" :
        return {
                TAG: "StmtLabel",
                stmtId: edlsGetId(diff),
                label: edlsGetStr(diff)
              };
    case "SM" :
        return {
                TAG: "StmtMove",
                stmtId: edlsGetId(diff),
                idx: edlsGetInt(diff)
              };
    case "SR" :
        return {
                TAG: "StmtRemove",
                stmtIds: edlsGetIds(diff)
              };
    case "SS" :
        return {
                TAG: "StmtStatus",
                stmtIds: edlsGetIds(diff),
                proofStatus: Belt_Option.map(diff.s, proofStatusFromStr)
              };
    case "ST" :
        return {
                TAG: "StmtTyp",
                stmtId: edlsGetId(diff),
                typ: MM_wrk_editor.userStmtTypeFromStr(edlsGetStr(diff)),
                isGoal: edlsGetBool(diff)
              };
    case "V" :
        return {
                TAG: "Vars",
                _0: edlsGetStr(diff)
              };
    default:
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "Cannot convert editorDiffLocStor to editorDiff for diff.typ='" + diff.t + "'."
            },
            Error: new Error()
          };
  }
}

function editorHistoryToLocStor(ht) {
  return {
          ver: ht.ver,
          head: editorSnapshotToLocStor(ht.head),
          prev: ht.prev.map(function (diff) {
                return diff.map(editorDiffToLocStor);
              }),
          maxLength: ht.maxLength
        };
}

function editorHistoryFromLocStor(ht) {
  return {
          ver: ht.ver,
          head: editorSnapshotFromLocStor(ht.head),
          prev: ht.prev.map(function (diff) {
                return diff.map(editorDiffFromLocStor);
              }),
          maxLength: ht.maxLength
        };
}

function editorHistToString(ht) {
  return Expln_utils_common.stringify(editorHistoryToLocStor(ht));
}

function parseStmtSnapshotLocStor(d) {
  return {
          d: Expln_utils_jsonParse.str(d, "d", undefined, undefined),
          l: Expln_utils_jsonParse.str(d, "l", undefined, undefined),
          t: Expln_utils_jsonParse.str(d, "t", undefined, undefined),
          g: Expln_utils_jsonParse.bool(d, "g", undefined, undefined),
          b: Expln_utils_jsonParse.bool(d, "b", undefined, undefined),
          j: Expln_utils_jsonParse.str(d, "j", undefined, undefined),
          c: Expln_utils_jsonParse.str(d, "c", undefined, undefined),
          p: Expln_utils_jsonParse.strOpt(d, "p", undefined, undefined)
        };
}

function editorHistFromString(jsonStr) {
  return Belt_Result.map(Expln_utils_jsonParse.parseJson(jsonStr, (function (__x) {
                    return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                  return {
                                          ver: Expln_utils_jsonParse.$$int(d, "ver", (function (v) {
                                                  if (v === 2) {
                                                    return {
                                                            TAG: "Ok",
                                                            _0: v
                                                          };
                                                  } else {
                                                    return {
                                                            TAG: "Error",
                                                            _0: "History protocol version mismatch, " + ("expected " + (2).toString() + ", got " + v.toString() + ".")
                                                          };
                                                  }
                                                }), undefined),
                                          head: Expln_utils_jsonParse.obj(d, "head", (function (d) {
                                                  return {
                                                          d: Expln_utils_jsonParse.str(d, "d", undefined, undefined),
                                                          v: Expln_utils_jsonParse.str(d, "v", undefined, undefined),
                                                          j: Expln_utils_jsonParse.str(d, "j", undefined, undefined),
                                                          s: Expln_utils_jsonParse.arr(d, "s", parseStmtSnapshotLocStor, undefined, undefined)
                                                        };
                                                }), undefined, undefined),
                                          prev: Expln_utils_jsonParse.arr(d, "prev", (function (d) {
                                                  return Expln_utils_jsonParse.asArr(d, (function (d) {
                                                                return {
                                                                        t: Expln_utils_jsonParse.str(d, "t", undefined, undefined),
                                                                        d: Expln_utils_jsonParse.strOpt(d, "d", undefined, undefined),
                                                                        b: Expln_utils_jsonParse.boolOpt(d, "b", undefined, undefined),
                                                                        i: Expln_utils_jsonParse.intOpt(d, "i", undefined, undefined),
                                                                        s: Expln_utils_jsonParse.strOpt(d, "s", undefined, undefined),
                                                                        m: Expln_utils_jsonParse.objOpt(d, "m", parseStmtSnapshotLocStor, undefined, undefined),
                                                                        a: Expln_utils_jsonParse.arrOpt(d, "a", (function (__x) {
                                                                                return Expln_utils_jsonParse.asStr(__x, undefined, undefined);
                                                                              }), undefined, undefined)
                                                                      };
                                                              }), undefined, undefined);
                                                }), undefined, undefined),
                                          maxLength: Expln_utils_jsonParse.$$int(d, "maxLength", undefined, undefined)
                                        };
                                }), undefined, undefined);
                  }), undefined, undefined), editorHistoryFromLocStor);
}

function stmtSnapshotToStringExtended(stmt) {
  var match = stmt.typ;
  var typStr;
  typStr = match === "E" ? "H" : (
      stmt.isGoal ? "G" : "P"
    );
  var bkmStr = stmt.isBkm ? "BKM " : "";
  var match$1 = stmt.proofStatus;
  var statusStr;
  if (match$1 !== undefined) {
    switch (match$1) {
      case "Ready" :
          statusStr = "\u2713";
          break;
      case "Waiting" :
          statusStr = "\u223F";
          break;
      case "NoJstf" :
          statusStr = "?";
          break;
      case "JstfIsIncorrect" :
          statusStr = "\u2717";
          break;
      
    }
  } else {
    statusStr = "";
  }
  return stmt.id + ": " + statusStr + " " + bkmStr + stmt.label + " " + typStr + " [" + stmt.jstfText + "] " + stmt.cont;
}

function editorSnapshotToStringExtended(sn) {
  var res = [];
  res.push("Description");
  res.push(sn.descr);
  if (sn.descr.length > 0) {
    res.push("");
  }
  res.push("Variables");
  res.push(sn.varsText);
  if (sn.varsText.length > 0) {
    res.push("");
  }
  res.push("Disjoints");
  res.push(sn.disjText);
  if (sn.disjText.length > 0) {
    res.push("");
  }
  sn.stmts.forEach(function (stmt) {
        res.push(stmtSnapshotToStringExtended(stmt));
      });
  return res.join("\n");
}

function diffToStringExtendedSingle(diff) {
  switch (diff.TAG) {
    case "Descr" :
        return "Descr(" + diff._0 + ")";
    case "Vars" :
        return "Vars(" + diff._0.replace(/[\n\r]+/g, " ; ") + ")";
    case "Disj" :
        return "Disj(" + diff._0.replace(/[\n\r]+/g, " ; ") + ")";
    case "StmtLabel" :
        return "StmtLabel({stmtId=" + diff.stmtId + ", label=" + diff.label + "})";
    case "StmtTyp" :
        return "StmtTyp({stmtId=" + diff.stmtId + ", typ=" + MM_wrk_editor.userStmtTypeToStr(diff.typ) + ", isGoal=" + Expln_utils_common.stringify(diff.isGoal) + "})";
    case "StmtBkm" :
        return "StmtBkm({stmtIds=[" + diff.stmtIds.join(", ") + "], isBkm=" + Expln_utils_common.stringify(diff.isBkm) + "})";
    case "StmtJstf" :
        return "StmtJstf({stmtId=" + diff.stmtId + ", jstfText=" + diff.jstfText + "})";
    case "StmtCont" :
        return "StmtCont({stmtId=" + diff.stmtId + ", cont=" + diff.cont + "})";
    case "StmtStatus" :
        return "StmtStatus({stmtIds=[" + diff.stmtIds.join(", ") + "], " + ("proofStatus=" + Belt_Option.getWithDefault(Belt_Option.map(diff.proofStatus, proofStatusToStr), "None") + "})");
    case "StmtAdd" :
        return "StmtAdd({idx=" + String(diff.idx) + ", stmtId=" + diff.stmt.id + "})";
    case "StmtRemove" :
        return "StmtRemove({stmtIds=[" + diff.stmtIds.join(", ") + "]})";
    case "StmtMove" :
        return "StmtMove({stmtId=" + diff.stmtId + ", idx=" + String(diff.idx) + "})";
    
  }
}

function diffToStringExtended(diff) {
  return diff.map(diffToStringExtendedSingle).join("\n");
}

function editorHistToStringExtended(ht) {
  var res = [];
  var delim2 = "====================================================================================";
  var curSn = {
    contents: ht.head
  };
  res.push(editorSnapshotToStringExtended(curSn.contents));
  res.push(delim2);
  ht.prev.forEach(function (diff) {
        res.push(diffToStringExtended(diff));
        res.push("------------------------------------------------------------------------------------");
        curSn.contents = applyDiff(curSn.contents, diff);
        res.push(editorSnapshotToStringExtended(curSn.contents));
        res.push(delim2);
      });
  return res.join("\n");
}

var a_stmts = [
  {
    id: "1",
    label: "label1",
    typ: "E",
    isGoal: false,
    isBkm: false,
    jstfText: "jstfText1",
    cont: "cont1",
    proofStatus: undefined
  },
  {
    id: "2",
    label: "label2",
    typ: "P",
    isGoal: false,
    isBkm: false,
    jstfText: "jstfText2",
    cont: "cont2",
    proofStatus: "Ready"
  },
  {
    id: "3",
    label: "label3",
    typ: "P",
    isGoal: true,
    isBkm: false,
    jstfText: "jstfText3",
    cont: "cont3",
    proofStatus: "Waiting"
  }
];

var a = {
  descr: "descr",
  varsText: "varsText",
  disjText: "disjText",
  stmts: a_stmts
};

function moveStmtTest(a, stmtId, dIdx) {
  var newStmts = a.stmts.slice();
  var idx = newStmts.findIndex(function (stmt) {
        return stmt.id === stmtId;
      });
  var tmp = newStmts[idx];
  newStmts[idx] = newStmts[idx + dIdx | 0];
  newStmts[idx + dIdx | 0] = tmp;
  return {
          descr: a.descr,
          varsText: a.varsText,
          disjText: a.disjText,
          stmts: newStmts
        };
}

function moveStmtUp(a, stmtId) {
  return moveStmtTest(a, stmtId, -1);
}

function moveStmtDown(a, stmtId) {
  return moveStmtTest(a, stmtId, 1);
}

function testApplyDiff(initState, changes, expectedEndState) {
  var diff = findDiff(initState, changes(initState));
  Expln_test.assertEq(diff.length > 0, true);
  var actualEndState = applyDiff(initState, diff);
  Expln_test.assertEq(actualEndState, expectedEndState);
}

function mm_editor_history__test_findDiff() {
  Expln_test.it("finds diffs", (function () {
          Expln_test.assertEq(findDiff(a, {
                    descr: "descr",
                    varsText: "varsText",
                    disjText: "disjText",
                    stmts: a_stmts
                  }), []);
          Expln_test.assertEq(findDiff(a, {
                    descr: "descr-new",
                    varsText: "varsText",
                    disjText: "disjText",
                    stmts: a_stmts
                  }), [{
                  TAG: "Descr",
                  _0: "descr-new"
                }]);
          Expln_test.assertEq(findDiff(a, {
                    descr: "descr",
                    varsText: "varsText-new",
                    disjText: "disjText",
                    stmts: a_stmts
                  }), [{
                  TAG: "Vars",
                  _0: "varsText-new"
                }]);
          Expln_test.assertEq(findDiff(a, {
                    descr: "descr",
                    varsText: "varsText",
                    disjText: "disjText-new",
                    stmts: a_stmts
                  }), [{
                  TAG: "Disj",
                  _0: "disjText-new"
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "1", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: "label-new",
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: "StmtLabel",
                  stmtId: "1",
                  label: "label-new"
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: "E",
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: "StmtTyp",
                  stmtId: "2",
                  typ: "E",
                  isGoal: false
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: true,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: "StmtTyp",
                  stmtId: "2",
                  typ: "P",
                  isGoal: true
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: "E",
                                  isGoal: true,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: "StmtTyp",
                  stmtId: "2",
                  typ: "E",
                  isGoal: true
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: true,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: "StmtBkm",
                  stmtIds: ["2"],
                  isBkm: true
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: "jstfText-new",
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: "StmtJstf",
                  stmtId: "3",
                  jstfText: "jstfText-new"
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "1", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: "cont-new",
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [{
                  TAG: "StmtCont",
                  stmtId: "1",
                  cont: "cont-new"
                }]);
          Expln_test.assertEq(findDiff(a, updateStmt(a, "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: undefined
                                };
                        }))), [{
                  TAG: "StmtStatus",
                  stmtIds: ["2"],
                  proofStatus: undefined
                }]);
          Expln_test.assertEq(findDiff({
                    descr: "descr",
                    varsText: "varsText",
                    disjText: "disjText",
                    stmts: []
                  }, addStmt({
                        descr: "descr",
                        varsText: "varsText",
                        disjText: "disjText",
                        stmts: []
                      }, 0, {
                        id: "4",
                        label: "label4",
                        typ: "E",
                        isGoal: true,
                        isBkm: false,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: "Ready"
                      })), [{
                  TAG: "StmtAdd",
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: "E",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: "Ready"
                  }
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(a, 0, {
                        id: "4",
                        label: "label4",
                        typ: "E",
                        isGoal: true,
                        isBkm: false,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: "Ready"
                      })), [{
                  TAG: "StmtAdd",
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: "E",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: "Ready"
                  }
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(a, 1, {
                        id: "4",
                        label: "label4",
                        typ: "P",
                        isGoal: true,
                        isBkm: false,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: "Ready"
                      })), [{
                  TAG: "StmtAdd",
                  idx: 1,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: "P",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: "Ready"
                  }
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(a, 2, {
                        id: "4",
                        label: "label4",
                        typ: "E",
                        isGoal: true,
                        isBkm: false,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: undefined
                      })), [{
                  TAG: "StmtAdd",
                  idx: 2,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: "E",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: undefined
                  }
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(a, 3, {
                        id: "4",
                        label: "label4",
                        typ: "P",
                        isGoal: true,
                        isBkm: false,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: undefined
                      })), [{
                  TAG: "StmtAdd",
                  idx: 3,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: "P",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: undefined
                  }
                }]);
          Expln_test.assertEq(findDiff(a, removeStmt(a, "1")), [{
                  TAG: "StmtRemove",
                  stmtIds: ["1"]
                }]);
          Expln_test.assertEq(findDiff(a, removeStmt(a, "2")), [{
                  TAG: "StmtRemove",
                  stmtIds: ["2"]
                }]);
          Expln_test.assertEq(findDiff(a, removeStmt(a, "3")), [{
                  TAG: "StmtRemove",
                  stmtIds: ["3"]
                }]);
          Expln_test.assertEq(findDiff(addStmt({
                        descr: "descr",
                        varsText: "varsText",
                        disjText: "disjText",
                        stmts: []
                      }, 0, {
                        id: "4",
                        label: "label4",
                        typ: "E",
                        isGoal: true,
                        isBkm: false,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: "Ready"
                      }), {
                    descr: "descr",
                    varsText: "varsText",
                    disjText: "disjText",
                    stmts: []
                  }), [{
                  TAG: "StmtRemove",
                  stmtIds: ["4"]
                }]);
          Expln_test.assertEq(findDiff(a, moveStmtDown(a, "1")), [{
                  TAG: "StmtMove",
                  stmtId: "2",
                  idx: 0
                }]);
          Expln_test.assertEq(findDiff(a, moveStmtDown(a, "2")), [{
                  TAG: "StmtMove",
                  stmtId: "3",
                  idx: 1
                }]);
          Expln_test.assertEq(findDiff(a, removeStmt(removeStmt(a, "1"), "2")), [{
                  TAG: "StmtRemove",
                  stmtIds: [
                    "1",
                    "2"
                  ]
                }]);
          Expln_test.assertEq(findDiff(a, addStmt(addStmt(a, 0, {
                            id: "4",
                            label: "label4",
                            typ: "E",
                            isGoal: true,
                            isBkm: false,
                            jstfText: "jstfText4",
                            cont: "cont4",
                            proofStatus: "Ready"
                          }), 2, {
                        id: "5",
                        label: "label5",
                        typ: "P",
                        isGoal: false,
                        isBkm: true,
                        jstfText: "jstfText5",
                        cont: "cont5",
                        proofStatus: "Waiting"
                      })), [
                {
                  TAG: "StmtAdd",
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: "E",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: "Ready"
                  }
                },
                {
                  TAG: "StmtAdd",
                  idx: 2,
                  stmt: {
                    id: "5",
                    label: "label5",
                    typ: "P",
                    isGoal: false,
                    isBkm: true,
                    jstfText: "jstfText5",
                    cont: "cont5",
                    proofStatus: "Waiting"
                  }
                }
              ]);
          Expln_test.assertEq(findDiff(a, moveStmtDown(a, "1")), [{
                  TAG: "StmtMove",
                  stmtId: "2",
                  idx: 0
                }]);
          Expln_test.assertEq(findDiff(a, moveStmtDown(moveStmtDown(a, "1"), "1")), [
                {
                  TAG: "StmtMove",
                  stmtId: "2",
                  idx: 0
                },
                {
                  TAG: "StmtMove",
                  stmtId: "3",
                  idx: 1
                }
              ]);
          Expln_test.assertEq(findDiff(a, moveStmtUp(a, "3")), [{
                  TAG: "StmtMove",
                  stmtId: "3",
                  idx: 1
                }]);
          Expln_test.assertEq(findDiff(a, moveStmtUp(moveStmtUp(a, "3"), "3")), [{
                  TAG: "StmtMove",
                  stmtId: "3",
                  idx: 0
                }]);
          Expln_test.assertEq(findDiff(updateStmt(updateStmt(updateStmt(a, "1", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: stmt.label,
                                          typ: stmt.typ,
                                          isGoal: stmt.isGoal,
                                          isBkm: stmt.isBkm,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: undefined
                                        };
                                })), "2", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      isBkm: stmt.isBkm,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: undefined
                                    };
                            })), "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: undefined
                                };
                        })), updateStmt(updateStmt(updateStmt(a, "1", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: stmt.label,
                                          typ: stmt.typ,
                                          isGoal: stmt.isGoal,
                                          isBkm: stmt.isBkm,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: "Ready"
                                        };
                                })), "2", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      isBkm: stmt.isBkm,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: "Waiting"
                                    };
                            })), "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: "JstfIsIncorrect"
                                };
                        }))), [
                {
                  TAG: "StmtStatus",
                  stmtIds: ["1"],
                  proofStatus: "Ready"
                },
                {
                  TAG: "StmtStatus",
                  stmtIds: ["2"],
                  proofStatus: "Waiting"
                },
                {
                  TAG: "StmtStatus",
                  stmtIds: ["3"],
                  proofStatus: "JstfIsIncorrect"
                }
              ]);
          Expln_test.assertEq(findDiff(a, updateStmt(updateStmt(updateStmt(addStmt({
                                    descr: "descr-new",
                                    varsText: "varsText-new",
                                    disjText: "disjText-new",
                                    stmts: a_stmts
                                  }, 0, {
                                    id: "4",
                                    label: "label4",
                                    typ: "E",
                                    isGoal: true,
                                    isBkm: true,
                                    jstfText: "jstfText4",
                                    cont: "cont4",
                                    proofStatus: "Ready"
                                  }), "1", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: "ABC",
                                          typ: stmt.typ,
                                          isGoal: stmt.isGoal,
                                          isBkm: stmt.isBkm,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: "NoJstf"
                                        };
                                })), "2", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: "E",
                                      isGoal: true,
                                      isBkm: stmt.isBkm,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: stmt.proofStatus
                                    };
                            })), "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: true,
                                  jstfText: "BBB",
                                  cont: "TTTTT",
                                  proofStatus: stmt.proofStatus
                                };
                        }))), [
                {
                  TAG: "StmtAdd",
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: "E",
                    isGoal: true,
                    isBkm: true,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: "Ready"
                  }
                },
                {
                  TAG: "StmtLabel",
                  stmtId: "1",
                  label: "ABC"
                },
                {
                  TAG: "StmtTyp",
                  stmtId: "2",
                  typ: "E",
                  isGoal: true
                },
                {
                  TAG: "StmtJstf",
                  stmtId: "3",
                  jstfText: "BBB"
                },
                {
                  TAG: "StmtCont",
                  stmtId: "3",
                  cont: "TTTTT"
                },
                {
                  TAG: "StmtBkm",
                  stmtIds: ["3"],
                  isBkm: true
                },
                {
                  TAG: "StmtStatus",
                  stmtIds: ["1"],
                  proofStatus: "NoJstf"
                },
                {
                  TAG: "Descr",
                  _0: "descr-new"
                },
                {
                  TAG: "Vars",
                  _0: "varsText-new"
                },
                {
                  TAG: "Disj",
                  _0: "disjText-new"
                }
              ]);
          Expln_test.assertEq(findDiff(a, addStmt(updateStmt(updateStmt(updateStmt(addStmt({
                                        descr: "descr-new",
                                        varsText: "varsText-new",
                                        disjText: "disjText-new",
                                        stmts: a_stmts
                                      }, 0, {
                                        id: "4",
                                        label: "label4",
                                        typ: "E",
                                        isGoal: true,
                                        isBkm: false,
                                        jstfText: "jstfText4",
                                        cont: "cont4",
                                        proofStatus: "Ready"
                                      }), "1", (function (stmt) {
                                      return {
                                              id: stmt.id,
                                              label: "ABC",
                                              typ: stmt.typ,
                                              isGoal: stmt.isGoal,
                                              isBkm: true,
                                              jstfText: stmt.jstfText,
                                              cont: stmt.cont,
                                              proofStatus: "NoJstf"
                                            };
                                    })), "2", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: stmt.label,
                                          typ: "E",
                                          isGoal: true,
                                          isBkm: stmt.isBkm,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: stmt.proofStatus
                                        };
                                })), "3", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      isBkm: stmt.isBkm,
                                      jstfText: "BBB",
                                      cont: "TTTTT",
                                      proofStatus: stmt.proofStatus
                                    };
                            })), 4, {
                        id: "5",
                        label: "label5",
                        typ: "E",
                        isGoal: true,
                        isBkm: true,
                        jstfText: "jstfText5",
                        cont: "cont5",
                        proofStatus: "Ready"
                      })), [
                {
                  TAG: "StmtAdd",
                  idx: 0,
                  stmt: {
                    id: "4",
                    label: "label4",
                    typ: "E",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: "Ready"
                  }
                },
                {
                  TAG: "StmtAdd",
                  idx: 4,
                  stmt: {
                    id: "5",
                    label: "label5",
                    typ: "E",
                    isGoal: true,
                    isBkm: true,
                    jstfText: "jstfText5",
                    cont: "cont5",
                    proofStatus: "Ready"
                  }
                },
                {
                  TAG: "StmtLabel",
                  stmtId: "1",
                  label: "ABC"
                },
                {
                  TAG: "StmtTyp",
                  stmtId: "2",
                  typ: "E",
                  isGoal: true
                },
                {
                  TAG: "StmtJstf",
                  stmtId: "3",
                  jstfText: "BBB"
                },
                {
                  TAG: "StmtCont",
                  stmtId: "3",
                  cont: "TTTTT"
                },
                {
                  TAG: "StmtBkm",
                  stmtIds: ["1"],
                  isBkm: true
                },
                {
                  TAG: "StmtStatus",
                  stmtIds: ["1"],
                  proofStatus: "NoJstf"
                },
                {
                  TAG: "Descr",
                  _0: "descr-new"
                },
                {
                  TAG: "Vars",
                  _0: "varsText-new"
                },
                {
                  TAG: "Disj",
                  _0: "disjText-new"
                }
              ]);
        }));
}

function mm_editor_history__test_applyDiff() {
  Expln_test.it("applies diffs", (function () {
          testApplyDiff(a, (function (sn) {
                  return {
                          descr: "descr-new",
                          varsText: sn.varsText,
                          disjText: sn.disjText,
                          stmts: sn.stmts
                        };
                }), {
                descr: "descr-new",
                varsText: "varsText",
                disjText: "disjText",
                stmts: a_stmts
              });
          testApplyDiff(a, (function (sn) {
                  return {
                          descr: sn.descr,
                          varsText: "varsText-new",
                          disjText: sn.disjText,
                          stmts: sn.stmts
                        };
                }), {
                descr: "descr",
                varsText: "varsText-new",
                disjText: "disjText",
                stmts: a_stmts
              });
          testApplyDiff(a, (function (sn) {
                  return {
                          descr: sn.descr,
                          varsText: sn.varsText,
                          disjText: "disjText-new",
                          stmts: sn.stmts
                        };
                }), {
                descr: "descr",
                varsText: "varsText",
                disjText: "disjText-new",
                stmts: a_stmts
              });
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "1", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: "label-new",
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        isBkm: stmt.isBkm,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "1", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: "label-new",
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "2", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: "E",
                                        isGoal: stmt.isGoal,
                                        isBkm: stmt.isBkm,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "2", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: "E",
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "2", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: true,
                                        isBkm: stmt.isBkm,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "2", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: true,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "2", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: "E",
                                        isGoal: true,
                                        isBkm: stmt.isBkm,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "2", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: "E",
                              isGoal: true,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "3", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        isBkm: true,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "3", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: true,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "3", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        isBkm: stmt.isBkm,
                                        jstfText: "jstfText-new",
                                        cont: stmt.cont,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "3", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: "jstfText-new",
                              cont: stmt.cont,
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "1", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        isBkm: stmt.isBkm,
                                        jstfText: stmt.jstfText,
                                        cont: "cont-new",
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(a, "1", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: "cont-new",
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return updateStmt(__x, "2", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        isBkm: stmt.isBkm,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: undefined
                                      };
                              }));
                }), updateStmt(a, "2", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: undefined
                            };
                    })));
          testApplyDiff(a, (function (__x) {
                  return addStmt(__x, 0, {
                              id: "4",
                              label: "label4",
                              typ: "E",
                              isGoal: true,
                              isBkm: false,
                              jstfText: "jstfText4",
                              cont: "cont4",
                              proofStatus: "Ready"
                            });
                }), addStmt(a, 0, {
                    id: "4",
                    label: "label4",
                    typ: "E",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: "Ready"
                  }));
          testApplyDiff(a, (function (__x) {
                  return addStmt(__x, 1, {
                              id: "4",
                              label: "label4",
                              typ: "P",
                              isGoal: true,
                              isBkm: false,
                              jstfText: "jstfText4",
                              cont: "cont4",
                              proofStatus: "Ready"
                            });
                }), addStmt(a, 1, {
                    id: "4",
                    label: "label4",
                    typ: "P",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: "Ready"
                  }));
          testApplyDiff(a, (function (__x) {
                  return addStmt(__x, 2, {
                              id: "4",
                              label: "label4",
                              typ: "E",
                              isGoal: true,
                              isBkm: false,
                              jstfText: "jstfText4",
                              cont: "cont4",
                              proofStatus: undefined
                            });
                }), addStmt(a, 2, {
                    id: "4",
                    label: "label4",
                    typ: "E",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: undefined
                  }));
          testApplyDiff(a, (function (__x) {
                  return addStmt(__x, 3, {
                              id: "4",
                              label: "label4",
                              typ: "P",
                              isGoal: true,
                              isBkm: false,
                              jstfText: "jstfText4",
                              cont: "cont4",
                              proofStatus: undefined
                            });
                }), addStmt(a, 3, {
                    id: "4",
                    label: "label4",
                    typ: "P",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText4",
                    cont: "cont4",
                    proofStatus: undefined
                  }));
          testApplyDiff(a, (function (__x) {
                  return removeStmt(__x, "1");
                }), removeStmt(a, "1"));
          testApplyDiff(a, (function (__x) {
                  return removeStmt(__x, "2");
                }), removeStmt(a, "2"));
          testApplyDiff(a, (function (__x) {
                  return removeStmt(__x, "3");
                }), removeStmt(a, "3"));
          testApplyDiff(a, (function (__x) {
                  return moveStmtDown(__x, "1");
                }), moveStmtDown(a, "1"));
          testApplyDiff(a, (function (__x) {
                  return moveStmtDown(__x, "2");
                }), moveStmtDown(a, "2"));
          testApplyDiff(a, (function (sn) {
                  return removeStmt(removeStmt(sn, "1"), "2");
                }), removeStmt(removeStmt(a, "1"), "2"));
          testApplyDiff(a, (function (sn) {
                  return addStmt(addStmt(sn, 0, {
                                  id: "4",
                                  label: "label4",
                                  typ: "E",
                                  isGoal: true,
                                  isBkm: false,
                                  jstfText: "jstfText4",
                                  cont: "cont4",
                                  proofStatus: "Ready"
                                }), 2, {
                              id: "5",
                              label: "label5",
                              typ: "P",
                              isGoal: false,
                              isBkm: true,
                              jstfText: "jstfText5",
                              cont: "cont5",
                              proofStatus: "Waiting"
                            });
                }), addStmt(addStmt(a, 0, {
                        id: "4",
                        label: "label4",
                        typ: "E",
                        isGoal: true,
                        isBkm: false,
                        jstfText: "jstfText4",
                        cont: "cont4",
                        proofStatus: "Ready"
                      }), 2, {
                    id: "5",
                    label: "label5",
                    typ: "P",
                    isGoal: false,
                    isBkm: true,
                    jstfText: "jstfText5",
                    cont: "cont5",
                    proofStatus: "Waiting"
                  }));
          testApplyDiff(a, (function (sn) {
                  return moveStmtDown(moveStmtDown(sn, "1"), "1");
                }), moveStmtDown(moveStmtDown(a, "1"), "1"));
          testApplyDiff(a, (function (sn) {
                  return updateStmt(updateStmt(updateStmt(sn, "1", (function (stmt) {
                                        return {
                                                id: stmt.id,
                                                label: stmt.label,
                                                typ: stmt.typ,
                                                isGoal: stmt.isGoal,
                                                isBkm: stmt.isBkm,
                                                jstfText: stmt.jstfText,
                                                cont: stmt.cont,
                                                proofStatus: undefined
                                              };
                                      })), "2", (function (stmt) {
                                    return {
                                            id: stmt.id,
                                            label: stmt.label,
                                            typ: stmt.typ,
                                            isGoal: stmt.isGoal,
                                            isBkm: stmt.isBkm,
                                            jstfText: stmt.jstfText,
                                            cont: stmt.cont,
                                            proofStatus: undefined
                                          };
                                  })), "3", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        isBkm: stmt.isBkm,
                                        jstfText: stmt.jstfText,
                                        cont: stmt.cont,
                                        proofStatus: undefined
                                      };
                              }));
                }), updateStmt(updateStmt(updateStmt(a, "1", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      isBkm: stmt.isBkm,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: undefined
                                    };
                            })), "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: undefined
                                };
                        })), "3", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: stmt.jstfText,
                              cont: stmt.cont,
                              proofStatus: undefined
                            };
                    })));
          testApplyDiff(a, (function (sn) {
                  return updateStmt(updateStmt(updateStmt(addStmt({
                                          descr: "descr-new",
                                          varsText: "varsText-new",
                                          disjText: "disjText-new",
                                          stmts: sn.stmts
                                        }, 0, {
                                          id: "4",
                                          label: "label4",
                                          typ: "E",
                                          isGoal: true,
                                          isBkm: false,
                                          jstfText: "jstfText4",
                                          cont: "cont4",
                                          proofStatus: "Ready"
                                        }), "1", (function (stmt) {
                                        return {
                                                id: stmt.id,
                                                label: "ABC",
                                                typ: stmt.typ,
                                                isGoal: stmt.isGoal,
                                                isBkm: stmt.isBkm,
                                                jstfText: stmt.jstfText,
                                                cont: stmt.cont,
                                                proofStatus: "NoJstf"
                                              };
                                      })), "2", (function (stmt) {
                                    return {
                                            id: stmt.id,
                                            label: stmt.label,
                                            typ: "E",
                                            isGoal: true,
                                            isBkm: stmt.isBkm,
                                            jstfText: stmt.jstfText,
                                            cont: stmt.cont,
                                            proofStatus: stmt.proofStatus
                                          };
                                  })), "3", (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        typ: stmt.typ,
                                        isGoal: stmt.isGoal,
                                        isBkm: stmt.isBkm,
                                        jstfText: "BBB",
                                        cont: "TTTTT",
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                }), updateStmt(updateStmt(updateStmt(addStmt({
                                descr: "descr-new",
                                varsText: "varsText-new",
                                disjText: "disjText-new",
                                stmts: a_stmts
                              }, 0, {
                                id: "4",
                                label: "label4",
                                typ: "E",
                                isGoal: true,
                                isBkm: false,
                                jstfText: "jstfText4",
                                cont: "cont4",
                                proofStatus: "Ready"
                              }), "1", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: "ABC",
                                      typ: stmt.typ,
                                      isGoal: stmt.isGoal,
                                      isBkm: stmt.isBkm,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: "NoJstf"
                                    };
                            })), "2", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: "E",
                                  isGoal: true,
                                  isBkm: stmt.isBkm,
                                  jstfText: stmt.jstfText,
                                  cont: stmt.cont,
                                  proofStatus: stmt.proofStatus
                                };
                        })), "3", (function (stmt) {
                      return {
                              id: stmt.id,
                              label: stmt.label,
                              typ: stmt.typ,
                              isGoal: stmt.isGoal,
                              isBkm: stmt.isBkm,
                              jstfText: "BBB",
                              cont: "TTTTT",
                              proofStatus: stmt.proofStatus
                            };
                    })));
          testApplyDiff(a, (function (param) {
                  return addStmt(updateStmt(updateStmt(updateStmt(addStmt({
                                              descr: "descr-new",
                                              varsText: "varsText-new",
                                              disjText: "disjText-new",
                                              stmts: a_stmts
                                            }, 0, {
                                              id: "4",
                                              label: "label4",
                                              typ: "E",
                                              isGoal: true,
                                              isBkm: false,
                                              jstfText: "jstfText4",
                                              cont: "cont4",
                                              proofStatus: "Ready"
                                            }), "1", (function (stmt) {
                                            return {
                                                    id: stmt.id,
                                                    label: "ABC",
                                                    typ: stmt.typ,
                                                    isGoal: stmt.isGoal,
                                                    isBkm: stmt.isBkm,
                                                    jstfText: stmt.jstfText,
                                                    cont: stmt.cont,
                                                    proofStatus: "NoJstf"
                                                  };
                                          })), "2", (function (stmt) {
                                        return {
                                                id: stmt.id,
                                                label: stmt.label,
                                                typ: "E",
                                                isGoal: true,
                                                isBkm: stmt.isBkm,
                                                jstfText: stmt.jstfText,
                                                cont: stmt.cont,
                                                proofStatus: stmt.proofStatus
                                              };
                                      })), "3", (function (stmt) {
                                    return {
                                            id: stmt.id,
                                            label: stmt.label,
                                            typ: stmt.typ,
                                            isGoal: stmt.isGoal,
                                            isBkm: stmt.isBkm,
                                            jstfText: "BBB",
                                            cont: "TTTTT",
                                            proofStatus: stmt.proofStatus
                                          };
                                  })), 4, {
                              id: "5",
                              label: "label5",
                              typ: "E",
                              isGoal: true,
                              isBkm: false,
                              jstfText: "jstfText5",
                              cont: "cont5",
                              proofStatus: "Ready"
                            });
                }), addStmt(updateStmt(updateStmt(updateStmt(addStmt({
                                    descr: "descr-new",
                                    varsText: "varsText-new",
                                    disjText: "disjText-new",
                                    stmts: a_stmts
                                  }, 0, {
                                    id: "4",
                                    label: "label4",
                                    typ: "E",
                                    isGoal: true,
                                    isBkm: false,
                                    jstfText: "jstfText4",
                                    cont: "cont4",
                                    proofStatus: "Ready"
                                  }), "1", (function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: "ABC",
                                          typ: stmt.typ,
                                          isGoal: stmt.isGoal,
                                          isBkm: stmt.isBkm,
                                          jstfText: stmt.jstfText,
                                          cont: stmt.cont,
                                          proofStatus: "NoJstf"
                                        };
                                })), "2", (function (stmt) {
                              return {
                                      id: stmt.id,
                                      label: stmt.label,
                                      typ: "E",
                                      isGoal: true,
                                      isBkm: stmt.isBkm,
                                      jstfText: stmt.jstfText,
                                      cont: stmt.cont,
                                      proofStatus: stmt.proofStatus
                                    };
                            })), "3", (function (stmt) {
                          return {
                                  id: stmt.id,
                                  label: stmt.label,
                                  typ: stmt.typ,
                                  isGoal: stmt.isGoal,
                                  isBkm: stmt.isBkm,
                                  jstfText: "BBB",
                                  cont: "TTTTT",
                                  proofStatus: stmt.proofStatus
                                };
                        })), 4, {
                    id: "5",
                    label: "label5",
                    typ: "E",
                    isGoal: true,
                    isBkm: false,
                    jstfText: "jstfText5",
                    cont: "cont5",
                    proofStatus: "Ready"
                  }));
        }));
}

exports.editorHistMake = editorHistMake;
exports.editorHistAddSnapshot = editorHistAddSnapshot;
exports.editorHistSetMaxLength = editorHistSetMaxLength;
exports.editorHistIsEmpty = editorHistIsEmpty;
exports.editorHistLength = editorHistLength;
exports.editorHistGetSnapshotPreview = editorHistGetSnapshotPreview;
exports.restoreEditorStateFromSnapshot = restoreEditorStateFromSnapshot;
exports.editorHistToString = editorHistToString;
exports.editorHistFromString = editorHistFromString;
exports.editorHistGetMaxIntStmtId = editorHistGetMaxIntStmtId;
exports.editorStatesHaveSameContent = editorStatesHaveSameContent;
exports.editorHistToStringExtended = editorHistToStringExtended;
exports.editorHistoryPrintIdInfo = editorHistoryPrintIdInfo;
exports.mm_editor_history__test_findDiff = mm_editor_history__test_findDiff;
exports.mm_editor_history__test_applyDiff = mm_editor_history__test_applyDiff;
/* ProofStatusHash Not a pure module */
